import { FC, useState } from "react"

import Button, { IButtonProps } from "components/Button/Button"

export interface IInlineControlsItemProps {
    onClick?(): Promise<void> | void
    disabled?: boolean
    label?: IButtonProps["label"]
}

const InlineControlsItem: FC<IInlineControlsItemProps> = ({
    onClick,
    disabled,
    label,
}) => {
    const [isHandling, setIsHandling] = useState(false)

    async function handleClick() {
        if (typeof onClick !== "function") return
        setIsHandling(true)
        await onClick()
        setIsHandling(false)
    }

    return (
        <Button
            theme="link"
            onClick={handleClick}
            label={label}
            disabled={!onClick || disabled || isHandling}
            loading={isHandling} />
    )
}

export default InlineControlsItem
